import { usePage } from '@inertiajs/react';
import { useEffect } from 'react';
import { toast } from 'sonner';

export function useFlashToasts() {
    const { props } = usePage<{ flash?: { success?: string; error?: string; warning?: string; message?: string } }>();
    const flash = props?.flash ?? {};

    useEffect(() => {
        if (flash?.success) toast.success(String(flash.success));
        if (flash?.error) toast.error(String(flash.error));
        if (flash?.warning) toast.warning(String(flash.warning));
        if (flash?.message) toast.info(String(flash.message));
    }, [flash?.success, flash?.error, flash?.warning, flash?.message]);
}
